var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},_vm._l((_vm.contentReasons),function(contentReason,index){return _c('content-detail',{key:index,attrs:{"items":_vm.getItems(contentReason),"all-prizes":_vm.allPrizes,"compressed":_vm.compressed,"row-type":_vm.getRowType (contentReason),"item-type":_vm.itemType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }